// import speakerChatroomActions from "./speakerChatroom/actions"

export default {
  saveEventAction({ commit }, payload) {
    commit("saveEventMutation", payload)
  },
  setUserInfoAction({ commit }, payload) {
    // state.user_info = payload
    commit("setUserInfo", payload)
  },
  hvuex({commit}, status) {
    // console.log(status, "statusstatusstatusstatusstatus")
    commit('hvuex', status)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js